import { render } from "./AboutS6.vue?vue&type=template&id=59af6ad0&scoped=true"
import script from "./AboutS6.vue?vue&type=script&lang=js"
export * from "./AboutS6.vue?vue&type=script&lang=js"

import "./AboutS6.vue?vue&type=style&index=0&id=59af6ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59af6ad0"]])

export default __exports__